import { render, staticRenderFns } from "./EventLogItem.vue?vue&type=template&id=bd66b63c&scoped=true"
import script from "./EventLogItem.vue?vue&type=script&lang=js"
export * from "./EventLogItem.vue?vue&type=script&lang=js"
import style0 from "./EventLogItem.vue?vue&type=style&index=0&id=bd66b63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd66b63c",
  null
  
)

export default component.exports